<template>
    <div class="filters">
        <div role="region" aria-labelledby="FilterResults">
            <hp5-heading size-selection="lg" tag-selection="h2" id="FilterResults">Filter results</hp5-heading>
            <hp5-spacing-vertical xs="xs" xl="xs" md="xs" lg="xs"></hp5-spacing-vertical>
            <FilterNetwork />
            <FilterBenefitLevel />
            <FilterCareNetwork />
            <FilterDistance />
            <FilterGender />
            <FilterLanguage />
            <FilterSpecialties />
            <FilterMedicalEquipment />
            <FilterServices />
            <FilterHospitalAffiliations />
            <FilterSocialDistinctions />
        </div> 
        <FilterControls />
    </div>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/breakpoints'  as *;

@include xsmall {
  .filters {
    hp5-heading {
      padding-top: 12px;
      padding-left: 12px;
    }
  }
}

</style>